import { clientDetection } from '../app/shared/globalFunctions/globalFunctions';

export const baseEnvironment = {
    production: false,
    API_URL: {
        CNMI: 'http://cnmi.localhost/insight/v7/api',
        MI: 'http://mi.localhost/insight/v7/api',
        MN: 'http://mn.localhost/insight/v7/api',
        MO: 'http://mo.localhost/insight/v7/api',
        MT: 'http://mt.localhost/insight/v7/api',
        ND: 'http://nd.localhost/insight/v7/api',
        NY: 'http://ny.localhost/insight/v7/api',
        OK: 'http://ok.localhost/insight/v7/api',
        PA: 'http://pa.localhost/insight/v7/api',
        PAEI: 'http://paei.localhost/insight/v7/api',
        SC: 'http://sc.localhost/insight/v7/api',
        WI: 'http://wi.localhost/insight/v7/api',
    } as Record<string, string>,
    authority: 'https://identityalt.newworldnow.com/',
    redirectUrl: 'http://localhost:4200/callback',
    clientId: `Training Provider ${clientDetection()} PWA(Local)`, //CREATE MAPPING BETWEEN REDIRECT AND CLIENT ID

    /** CDN Information */
    cdnBaseClientCode: 'Base',
    cdnHost: 'https://insightcdn.newworldnow.com/',
    cdnProject: 'Registry',

    /** SmartLabel Information */
    smartLabelsBasePath: '/smartlabels',
    smartLabelsDefaultLocale: 'en-US',
};
